import { render, staticRenderFns } from "./r-treasure-lower-cap-config-panel.vue?vue&type=template&id=15ba576c"
import script from "./r-treasure-lower-cap-config-panel.vue?vue&type=script&lang=js"
export * from "./r-treasure-lower-cap-config-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ba576c')) {
      api.createRecord('15ba576c', component.options)
    } else {
      api.reload('15ba576c', component.options)
    }
    module.hot.accept("./r-treasure-lower-cap-config-panel.vue?vue&type=template&id=15ba576c", function () {
      api.rerender('15ba576c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-lower-cap-config-panel.vue"
export default component.exports